import React, { Component } from 'react';

import PropTypes from 'prop-types';

import CanvasMenuButton from '../menu/CanvasMenuButton';

export default class CanvasTextFontWeight extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    onUpdate: PropTypes.func,
    updateInfo: PropTypes.func,
    isAllBold: PropTypes.bool
  };

  isBold(item) {
    if ('fontWeight' in item) {
      return item.fontWeight.indexOf('bold') >= 0;
    }
    return false;
  }

  isNormalize(canvasRef) {
    let activeObjects = canvasRef.getActiveObjects();
    const isAllSeted = activeObjects.every(this.isBold);
    const isAllNotSet = activeObjects.every((item) => !this.isBold(item));
    const needNormalize =
      !isAllNotSet && !isAllSeted && activeObjects.length > 1;

    if (needNormalize) {
      activeObjects = activeObjects.filter((item) => this.isBold(item));
    }

    return activeObjects;
  }

  toggleBold() {
    const { canvasRef, onUpdate, updateInfo } = this.props;

    const activeObjects = this.isNormalize(canvasRef);

    activeObjects.forEach((item) => {
      if (this.isBold(item)) {
        item.set({ fontWeight: '' });
      } else {
        item.set({ fontWeight: 'bold' });
      }
    });

    canvasRef.renderAll();

    onUpdate();
    updateInfo();
  }

  render() {
    const { isAllBold } = this.props;

    return (
      <CanvasMenuButton
        onClick={this.toggleBold.bind(this)}
        toolTip="canvas-editor.text.bold"
        icon="bold"
        active={isAllBold}
      />
    );
  }
}
